/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Section_FeaturesInputs */

const en_marketing_section_features = /** @type {(inputs: Marketing_Section_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const es_marketing_section_features = /** @type {(inputs: Marketing_Section_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const fr_marketing_section_features = /** @type {(inputs: Marketing_Section_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Marketing_Section_FeaturesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_section_features = /** @type {((inputs?: Marketing_Section_FeaturesInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Section_FeaturesInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_section_features(inputs)
	if (locale === "es") return es_marketing_section_features(inputs)
	return fr_marketing_section_features(inputs)
});